$('iframe[src*="youtube.com"],iframe[src*="vimeo.com"]').each(function() {
	$(this)
		.wrap("<div class='videoWrapper'/>")
		.wrap("<div class='videoIframe'/>");
});